var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "footer-box" },
    [
      _c("flex", { attrs: { justify: "between" } }, [
        _c(
          "div",
          [
            _c("img", {
              staticClass: "logo-img",
              attrs: { src: require("@/static/img/home/logo-white.png") },
            }),
            _vm._v(" "),
            _c("flex", { staticClass: "link-box" }, [
              _c(
                "a",
                {
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.gotoAboutUs()
                    },
                  },
                },
                [_vm._v("关于我们")]
              ),
              _vm._v(" "),
              _c("a", [_vm._v("使用指南")]),
              _vm._v(" "),
              _c("a", [_vm._v("授权协议")]),
              _vm._v(" "),
              _c("a", [_vm._v("隐私策略")]),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("flex", { staticClass: "app-box", attrs: { align: "center" } }, [
              _c("img", {
                attrs: { src: require("@/static/img/home/app-icon.png") },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("视阅APP")]),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "app-sumarry" }, [
              _vm._v(
                "视阅app客户端是专业的智慧化媒体和产业服务平台。以期刊出版为引领，提供书刊订阅、影像摄制、研学旅行、创意设计、会务会展、教育培训、文化旅游和品牌推广等服务。"
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "divider" }),
      _vm._v(" "),
      _c(
        "flex",
        { attrs: { justify: "between" } },
        [
          _c("div", { staticClass: "info-wrapper" }, [
            _c("p", [
              _vm._v("@贵州新闻图片社有限公司\n        "),
              _c(
                "a",
                {
                  staticStyle: { color: "#fff" },
                  attrs: {
                    href: "https://beian.miit.gov.cn/",
                    target: "_blank",
                  },
                },
                [_vm._v("黔ICP备13002800号-2")]
              ),
              _vm._v(" 营业执照：91520000429200283Q\n      "),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "热线：0851-86822572工作日9:00 - 17:00 投稿邮箱：646896024@qq.com"
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "贵州省贵阳市观山湖区长岭北路贵阳国际会议展览中心D区D1栋7-18层1号"
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "flex",
            { staticClass: "qrcode-wrapper", attrs: { justify: "between" } },
            [
              _c(
                "flex",
                {
                  staticClass: "qrcode-item",
                  attrs: {
                    direction: "column",
                    jutify: "center",
                    align: "center",
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/static/img/home/newshiyuelogo.jpg"),
                    },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("下载视阅app")]),
                ]
              ),
              _vm._v(" "),
              _c(
                "flex",
                {
                  staticClass: "qrcode-item",
                  attrs: {
                    direction: "column",
                    jutify: "center",
                    align: "center",
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/static/img/home/shiyuxiaochengxu.jpg"),
                    },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("视阅小程序")]),
                ]
              ),
              _vm._v(" "),
              _c(
                "flex",
                {
                  staticClass: "qrcode-item",
                  attrs: {
                    direction: "column",
                    jutify: "center",
                    align: "center",
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/static/img/home/shiyugongzhonghao.jpg"),
                    },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("微信公众号")]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }